import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSpeakerOutlined = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4 13.9984 1.5747 6.2986c.0442.1772.0664.2657.0926.3431a2 2 0 0 0 1.7312 1.3517c.0814.0066.1727.0066.3553.0066.2286 0 .343 0 .4393-.0093a2 2 0 0 0 1.7976-1.7976C10 20.0952 10 19.9809 10 19.7522V5.4985m8.5 7.9999c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5m-8.25-1H6.5c-2.4853 0-4.5 2.0148-4.5 4.5 0 2.4853 2.0147 4.5 4.5 4.5h3.75c1.7664 0 3.9272.9469 5.5943 1.8557.9725.5301 1.4588.7952 1.7773.7562.2953-.0362.5186-.1688.6917-.4107.1867-.261.1867-.7832.1867-1.8274V5.1247c0-1.0443 0-1.5664-.1867-1.8274-.1731-.242-.3964-.3745-.6917-.4107-.3185-.039-.8048.226-1.7773.7562-1.6671.9088-3.8279 1.8557-5.5943 1.8557"
    />
  </svg>
);
export default SvgSpeakerOutlined;
